import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-funktionsbereich-aufgaben-benutzer-berechtigungen-excel';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenExcelEffects {

    VeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenExcel$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_EXCEL),
        mergeMap((x: ac.GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenExcelAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenExcel(x.veranstaltung_id, x.funktionsbereich_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenExcelErfolgreichAction(result, x.veranstaltung_id, x.funktionsbereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenExcelFehlerAction(error, x.veranstaltung_id, x.funktionsbereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
